var _style, _circle, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C172.2,0,97.9,40.2,51.2,102.4h409.6C414.1,40.2,339.8,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c83.8,0,158.1-40.2,204.8-102.4H51.2C97.9,471.8,172.2,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,256c0,17.5,1.8,34.7,5.1,51.2h501.7c3.4-16.5,5.1-33.7,5.1-51.2s-1.8-34.7-5.1-51.2H5.1 C1.8,221.3,0,238.5,0,256L0,256z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,75C-25,175-25,337,75,437c41.3-41.3,81-81,181-181L75,75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.6,189.2l16.6,51h53.6l-43.4,31.5l16.6,51l-43.4-31.5l-43.4,31.5l16.6-51l-43.4-31.5H87L103.6,189.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.ec8cb35c8bff37c20ea58e7b24b6d718.svg";
export { ForwardRef as ReactComponent };